import React, { Component } from 'react';
import styles from './LandingPage.module.css';
import MainGreeting from '../../components/Greeting/MainGreeting';

export default class extends Component {
  redirectHandler = () => {
    this.props.history.push('/login');
  };

  render() {
    return (
      <div className={[styles.Container, 'container'].join(' ')}>
        <MainGreeting className={styles.Greeting} redirectHandler={this.redirectHandler} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/LandingPage/LandingPage.js